import { createFileRoute } from '@tanstack/react-router';
import { UserResearchView } from '@/components/admin/user-research';

export const Route = createFileRoute('/_authed/admin/user-research/')({
  component: UserResearchPage,
});

function UserResearchPage() {
  return <UserResearchView />;
}
